<template>
  <div class="auth-container">
    <div v-if="!isAuthenticated">
      <h2>Вхід через OIDC</h2>
      <button @click="login">Увійти</button>
    </div>
    
    <div v-else>
      <h2>Ви авторизовані</h2>
      <p>Ім'я користувача: {{ user?.profile?.name }}</p>
      <p>Email: {{ user?.profile?.email }}</p>
      <button @click="logout">Вийти</button>
    </div>
  </div>
</template>

<script>
import { userManager } from '../router'

export default {
  name: "Login",

  data() {
    return {
      user: null,
      loading: true,
      isAuthenticated: false
    }
  },

  async mounted() {
    this.user = await userManager.getUser()
    this.loading = false
    this.isAuthenticated = !!this.user && !this.user?.expired    
  },

  methods: {
    login() {
      userManager.signinRedirect({
        state: { returnUrl: "/" }
      })
    },
    logout() {
      userManager.signoutRedirect()
    }
  }
}

</script>

<style scoped>
.auth-container {
  padding: 20px;
  max-width: 400px;
  margin: 0 auto;
}

button {
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
  background-color: #42b983;
  color: white;
  border: none;
  border-radius: 4px;
}

button:hover {
  background-color: #359268;
}
</style>